import { render, staticRenderFns } from "./_resetPassword.vue?vue&type=template&id=39eba1f9&scoped=true&lang=pug&"
import script from "./_resetPassword.vue?vue&type=script&lang=js&"
export * from "./_resetPassword.vue?vue&type=script&lang=js&"
import style0 from "./_resetPassword.vue?vue&type=style&index=0&id=39eba1f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eba1f9",
  null
  
)

export default component.exports